import { BookOpen } from 'lucide-react'
import { SegmentedControl } from '@teach/ui'
import { QuotePlate } from '@/features/ai/components/QuotePlate'
import type { CourseQuoteView } from '@/features/ai/useCourseQuote'
import type { LessonCount } from '@/features/ai/useStartGeneration'
import type { GenerationSettingsState } from './useGenerationSettings'
import { useMessages } from '@/i18n'
import { messages } from './sidebarMessages'

const SectionTitle = ({
  icon: Icon,
  children,
}: {
  icon: typeof BookOpen
  children: React.ReactNode
}) => (
  <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
    <Icon className="h-3.5 w-3.5" />
    {children}
  </div>
)

/**
 * Дизайн-система, иллюстрации и источник (ссылка/файл/MD) отсюда убраны
 * (Task 11) — под всеми тремя нет бэка: ручки со списком моделей картинок
 * нет, дизайн-систем в API нет вовсе, импорта нет ни там, ни у нас.
 * Языкового пикера здесь нет и не будет — см. `useGenerationSettings`.
 *
 * Смета (I-2) — та же плашка, что на главной: спека §10 называет `QuotePlate`
 * общей плашкой ДВУХ поверхностей. Без неё автор в существующем курсе платит,
 * не видя ни цены, ни баланса, и узнаёт о нехватке кредитов из `400`.
 */
export const GenerationSettings = ({
  settings,
  quote,
}: {
  settings: GenerationSettingsState
  quote: CourseQuoteView
}) => {
  const m = useMessages(messages)
  return (
    // Скроллбар прячем нашей утилитой .scrollbar-hide (src/index.css) — реф делает
    // то же самое арбитрарными классами.
    <div className="scrollbar-hide min-h-0 flex-1 overflow-y-auto overflow-x-hidden pb-4 pl-5 pr-7 pt-2">
      <div className="space-y-6 px-1">
        <div className="space-y-2">
          <SectionTitle icon={BookOpen}>{m.lessonCount}</SectionTitle>
          <SegmentedControl
            fullWidth
            size="sm"
            options={[
              { id: '3', label: '3' },
              { id: '5', label: '5' },
              { id: '10', label: '10' },
            ]}
            value={String(settings.lessonCount)}
            onChange={(id) => settings.setLessonCount(Number(id) as LessonCount)}
          />
          <QuotePlate price={quote.price} balance={quote.balance} isLoading={quote.isLoading} />
        </div>
      </div>
    </div>
  )
}
